import DenySwipeDialog from './DenySwipeDialog';
export default DenySwipeDialog;